import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../../theming/useTheme';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { useHeaderHeights } from '../../components/navigation/header/useHeaderHeights';
import { BodyTag } from './BodyTag';
import { MainWrapperConfigThemeKey, MainWrapperThemeProps } from './mainWrapper.theme';

interface MainWrapperForHeaderWithSubMenusProps {
    configThemeKey: MainWrapperConfigThemeKey;
}

export const MainWrapperForNavigation: React.FunctionComponent<MainWrapperForHeaderWithSubMenusProps> = ({ children, configThemeKey }) => {
  const { baseUnit, backgroundColor, paddingFactor, maxWidth } = useTheme<MainWrapperThemeProps>(configThemeKey);
  const headerHeights = useHeaderHeights();

  const style = {
    backgroundColor,
    maxWidth: `${maxWidth}px`,
    margin: '0 auto',
    paddingBottom: `${baseUnit}px`,
    [MEDIA_BREAKPOINTS.large]: {
      marginTop: `${headerHeights.large * baseUnit + baseUnit * paddingFactor}px`,
    },
    [MEDIA_BREAKPOINTS.medium]: {
      marginTop: `${headerHeights.medium * baseUnit + baseUnit * paddingFactor}px`,
    },
    [MEDIA_BREAKPOINTS.small]: {
      marginTop: `${headerHeights.small * baseUnit + baseUnit * paddingFactor}px`,
    },
  };

  return (
    <React.Fragment>
      <BodyTag mainConfigThemeKey={configThemeKey} />
      <main
        className={css(StyleSheet.create({ style }).style)}
      >
        {children}
      </main>
    </React.Fragment>
  );
};
